<template>
  <AdsTemplate>
    <div id="ticker-page" class="match-list-container">
      <MatchControl
        :filters="filters"
        :signal-filters="signalFilters"
        :sorting="sorting"
        :constants="constants"
      />
      <div class="match-list">
        <Pagination
          :page="page"
          :total="matches.total"
          :per-page="perPage"
          @input="page = $event"
        ></Pagination>
        <Match
          v-for="match in matches.data"
          :id="match.id"
          :key="match.id"
          :data="match.data || []"
          :history-signal="$can('TICKER_SIGNAL') ? match.historySignal : []"
          :filtered="$can('TICKER_DATA') ? match.filtered : {}"
          :away-name="match.awayName"
          :away-red-cards="match.awayRedCards"
          :away-score="match.awayScore"
          :away-yellow-cards="match.awayYellowCards"
          :away-score-changed="match.awayScoreChanged"
          :home-name="match.homeName"
          :home-red-cards="match.homeRedCards"
          :home-score="match.homeScore"
          :home-yellow-cards="match.homeYellowCards"
          :home-score-changed="match.homeScoreChanged"
          :league="match.league"
          :time="match.time"
          :is-favorite="match.isFavorite"
          :time-level-class="match.$timeLevel"
          :mini="match.mini"
          :match="match"
          :home="match.home"
          :away="match.away"
          :permision="user ? user.permision : ''"
          @view="toggleMatchView(match.id)"
          @favorite="setFavoriteMatch(match.id)"
        ></Match>
        <Pagination
          :page="page"
          :total="matches.total"
          :per-page="perPage"
          @input="page = $event"
        ></Pagination>
      </div>
    </div>
  </AdsTemplate>
</template>

<script>
import AdsTemplate from "./AdsTemplate.vue";
import Pagination from "../components/Pagination.vue";
import Match from "../components/TickerMatch.vue";
import MatchControl from "../components/common/MatchControl.vue";
import {
  MATCH_FILTER_KEYS,
  SIGNAL_FILTER_NAMES,
  SORT_TYPES
} from "../store/utils/constant";

const filters = [
  MATCH_FILTER_KEYS.ALL,
  MATCH_FILTER_KEYS.FAVORITES,
  MATCH_FILTER_KEYS.SIGNALS,
];
const sorting = [SORT_TYPES.SIGNAL, SORT_TYPES.TIME];

export default {
  name: "Ticker",
  components: { Match, AdsTemplate, Pagination, MatchControl },
  data() {
    return {
      page: 1,
      perPage: 20,
      fetchTimeout: null,
      maxHistory: 3,
      constants: { CATEGORY: "match", MATCH_FILTER_KEYS },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    filters() {
      return this.$store.getters.tickerFiltres(filters);
    },
    signalFilters() {
      return this.$store.getters.tickerSignalFiltres(
        Object.keys(SIGNAL_FILTER_NAMES),
      );
    },
    sorting() {
      return this.$store.getters.tickerSorting(sorting);
    },
    matches() {
      const opts = { page: this.page, perPage: this.perPage };
      return this.$store.getters.tikerMatches(opts);
    },
  },
  async mounted() {
    this.$store.commit("SET_SORT", { type: SORT_TYPES.SIGNAL, order: "DESC" });
  },
  methods: {
    toggleMatchView(id) {
      // A-9: гейтинг на контроле (<Lock> в HeaderMatch), здесь только действие
      this.$store.commit("TOGLE_TICKER_EXPANDED", id);
    },
    setFavoriteMatch(id) {
      this.$store.dispatch("toggleFavorite", id);
    },
  },
};
</script>

<style lang="scss" scoped>
#ticker-page {
  margin-top: 0.75rem;
}
</style>
